var _defs, _rect, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect2, _path, _path2, _path3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect3, _rect4, _rect5, _rect6, _line6, _line7, _rect7, _line8, _line9, _rect8, _circle9, _rect9, _rect0, _rect1, _circle0, _polygon7, _polygon8, _rect10, _polygon9, _rect11, _polygon0, _polygon1, _rect12, _polygon10, _rect13, _text, _text2, _line0, _line1, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skyGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c8eaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e8f6fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt1Grad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7bbf96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4a8b68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt2Grad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3e7a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2d6a4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt3Grad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#55936f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3d7a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "riverGrad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#52bbd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#3aa8c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#52bbd8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logoClip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 20
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#skyGrad)",
    rx: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 65,
    r: 32,
    fill: "#ffd166",
    opacity: 0.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 65,
    r: 22,
    fill: "#ffb830"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 22,
    x2: 330,
    y2: 10,
    stroke: "#ffd166",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 363,
    y1: 32,
    x2: 371,
    y2: 24,
    stroke: "#ffd166",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 373,
    y1: 65,
    x2: 387,
    y2: 65,
    stroke: "#ffd166",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 363,
    y1: 98,
    x2: 371,
    y2: 106,
    stroke: "#ffd166",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 297,
    y1: 32,
    x2: 289,
    y2: 24,
    stroke: "#ffd166",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90,220 200,50 310,220",
    fill: "url(#mt1Grad)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "200,50 178,105 222,105",
    fill: "white",
    opacity: 0.88
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0,220 100,80 190,220",
    fill: "url(#mt2Grad)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "100,80 83,120 117,120",
    fill: "white",
    opacity: 0.82
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "210,220 305,95 400,220",
    fill: "url(#mt3Grad)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "305,95 288,130 322,130",
    fill: "white",
    opacity: 0.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216,
    width: 400,
    height: 10,
    fill: "#4a8b5a",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,230 Q50,215 100,228 Q150,241 200,228 Q250,215 300,228 Q350,241 400,228            L400,255 Q350,268 300,255 Q250,242 200,255 Q150,268 100,255 Q50,242 0,255 Z",
    fill: "url(#riverGrad)",
    opacity: 0.92
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,236 Q70,230 110,236",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200,238 Q245,231 285,238",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    opacity: 0.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 230,
    r: 18,
    fill: "#333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 230,
    r: 10,
    fill: "#666"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 230,
    r: 4,
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 230,
    r: 18,
    fill: "#333"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 230,
    r: 10,
    fill: "#666"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 230,
    r: 4,
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 170,
    width: 148,
    height: 60,
    rx: 8,
    fill: "#fdf6e3",
    stroke: "#c0a055",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 162,
    width: 148,
    height: 18,
    rx: 9,
    fill: "#e2c97a",
    stroke: "#c0a055",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 178,
    width: 148,
    height: 5,
    fill: "#2d6a4f",
    opacity: 0.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 185,
    width: 28,
    height: 20,
    rx: 3,
    fill: "#a8dff0",
    stroke: "#7abcce",
    strokeWidth: 1.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 141,
    y1: 185,
    x2: 141,
    y2: 205,
    stroke: "#7abcce",
    strokeWidth: 0.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 127,
    y1: 195,
    x2: 155,
    y2: 195,
    stroke: "#7abcce",
    strokeWidth: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 185,
    width: 28,
    height: 20,
    rx: 3,
    fill: "#a8dff0",
    stroke: "#7abcce",
    strokeWidth: 1.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 177,
    y1: 185,
    x2: 177,
    y2: 205,
    stroke: "#7abcce",
    strokeWidth: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 195,
    x2: 191,
    y2: 195,
    stroke: "#7abcce",
    strokeWidth: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 183,
    width: 22,
    height: 47,
    rx: 3,
    fill: "#c9903a",
    stroke: "#a87230",
    strokeWidth: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 207,
    r: 3,
    fill: "#7a5020"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 187,
    width: 14,
    height: 12,
    rx: 1.5,
    fill: "#d9a050",
    opacity: 0.6
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 203,
    width: 14,
    height: 12,
    rx: 1.5,
    fill: "#d9a050",
    opacity: 0.6
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 208,
    width: 30,
    height: 5,
    rx: 2.5,
    fill: "#888"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 210.5,
    r: 6,
    fill: "#666",
    stroke: "#555",
    strokeWidth: 1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "38,220 52,172 66,220",
    fill: "#2d6a4f"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "40,205 52,162 64,205",
    fill: "#3d7a59"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 220,
    width: 5,
    height: 10,
    fill: "#7a5c3a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "18,220 28,193 38,220",
    fill: "#3d7a59"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 220,
    width: 4,
    height: 7,
    fill: "#7a5c3a"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "340,220 354,175 368,220",
    fill: "#2d6a4f"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "342,207 354,166 366,207",
    fill: "#3d7a59"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 220,
    width: 5,
    height: 10,
    fill: "#7a5c3a"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "360,220 371,196 382,220",
    fill: "#3d7a59"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 220,
    width: 4,
    height: 7,
    fill: "#7a5c3a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 305,
    fontFamily: "'Trebuchet MS', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 400,
    letterSpacing: 8,
    textAnchor: "middle",
    fill: "#2d6a4f",
    opacity: 0.85
  }, "CAMPING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 348,
    fontFamily: "'Trebuchet MS', Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700,
    letterSpacing: 2,
    textAnchor: "middle",
    fill: "#1b4332"
  }, "SPIRKENHOF")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 320,
    x2: 140,
    y2: 320,
    stroke: "#2d6a4f",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 320,
    x2: 370,
    y2: 320,
    stroke: "#2d6a4f",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 378,
    fontFamily: "'Trebuchet MS', Arial, sans-serif",
    fontSize: 13,
    textAnchor: "middle",
    fill: "#40916c",
    opacity: 0.8
  }, "www.camping-spirkenhof.at")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8cdbd71d7dbf814959ab83994c98a2b9.svg";
export { ForwardRef as ReactComponent };